import { CultureInfo } from '../culture-info.model';
import { CultureInfoHr } from './hr';

/**
 * @ignore
 */
export const CultureInfoHrBA: CultureInfo = {
  name: 'hr-BA',
  displayName: 'Croatian (Bosnia & Herzegovina)',
  iso3LanguageCode: 'hrv',
  iso2LanguageCode: 'hr',
  ietfLanguageTag: 'hr-BA',
  parent: CultureInfoHr
};
